//----------------------------------------------------
// src/components/PinturaDemo.jsx — Logboek24 foto-editor met upload & preview-link
//----------------------------------------------------
import React, { useRef, useState } from "react";
import {
  openDefaultEditor,
  setPlugins,
  plugin_crop,
  plugin_annotate,
  plugin_filter,
  plugin_resize,
} from "@pqina/pintura";
import locale_nl_NL from "@pqina/pintura/locale/nl_NL";
import "@pqina/pintura/pintura.css";
import { apiUrl } from "../config/api";

setPlugins(plugin_crop, plugin_annotate, plugin_filter, plugin_resize);

export default function PinturaDemo() {
  const inputRef = useRef();
  const [preview, setPreview] = useState(null);
  const [serverFile, setServerFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // ✏️ Open de editor in het Nederlands
    const edited = await openDefaultEditor({
      src: URL.createObjectURL(file),
      locale: locale_nl_NL,
      imageCropAspectRatio: 1,
      imageWriter: { mimeType: "image/jpeg", quality: 0.9 },
    });

    if (!edited || !edited.dest) return;

    // Toon preview
    setPreview(edited.dest);

    // Upload naar backend
    const blob = await fetch(edited.dest).then((r) => r.blob());
    const formData = new FormData();
    formData.append("file", blob, file.name);

    const token = localStorage.getItem("token");
    try {
      setUploading(true);
      const res = await fetch(apiUrl("/api/surveys/upload"), {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });
      const data = await res.json();

      if (data.fileUrl) {
        console.log("✅ Upload succesvol:", data.fileUrl);
        setServerFile(apiUrl(data.fileUrl));
      } else {
        console.warn("⚠️ Upload voltooid maar geen fileUrl ontvangen:", data);
      }
    } catch (err) {
      console.error("❌ Upload mislukt:", err);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="p-4 bg-white rounded-xl shadow-md w-full max-w-lg mx-auto">
      <h2 className="text-lg font-semibold mb-3">📸 Foto bewerken (Pintura)</h2>
      <input
        type="file"
        accept="image/*"
        ref={inputRef}
        onChange={handleFileChange}
        className="mb-4"
      />

      {uploading && <p className="text-blue-500">Bezig met uploaden...</p>}

      {preview && (
        <div className="mb-4">
          <img
            src={preview}
            alt="preview"
            className="rounded-lg border border-gray-300 shadow-sm"
          />
        </div>
      )}

      {serverFile && (
        <p className="text-sm text-green-700">
          ✅ Bestand opgeslagen op server:&nbsp;
          <a
            href={serverFile}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline hover:text-blue-800"
          >
            {serverFile}
          </a>
        </p>
      )}
    </div>
  );
}
